import React from 'react';
import { numberWithCommas } from '../../util/CommonUtils';

const GeoMapTooltip = ({ toolTipRef, toolTipData }) => {
  const { tw, i, h, bw, ts, g } = toolTipData;

  return (
    <div className="heatMap__tooltip" ref={toolTipRef}>
      <h6 className="heatMap__title">{g || 'Geographies'}</h6>
      <p className="heatMap__text">Sample: {numberWithCommas(ts) || 0}</p>
      <p className="heatMap__text">
        Target Weighted: {numberWithCommas(tw) || 0}
      </p>
      <p className="heatMap__text">
        Base Weighted: {numberWithCommas(bw) || 0}
      </p>
      <p className="heatMap__text">Horizontal %: {Math.round(h) || 0}%</p>
      <p className="heatMap__text">Index: {i || 0}</p>
    </div>
  );
};

export default GeoMapTooltip;
